import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  container: {
    padding: "24px 40px",
    minHeight: "calc(100vh - 200px)",
  },
  header: {
    display: "flex",
    alignItems: "center",
    marginBottom: 32,
    fontSize: 24,
    fontWeight: 600,
    color: theme.palette.primary.main,
    "& svg": {
      marginRight: 12,
      fontSize: 28,
    },
  },
  content: {
    width: "100%",
  },
  productsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(340px, 1fr))",
    gap: 24,
    marginTop: 24,
  },
  [theme.breakpoints.down("xs")]: {
    container: {
      padding: "20px 16px",
    },
    productsGrid: {
      gridTemplateColumns: "1fr",
    },
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 400,
  },
  emptyContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 400,
    fontSize: 16,
    color: "#666",
  },
}));
